<project-details-info-header [project]="project"></project-details-info-header>


<div *ngIf="pageStatus == STATUS_DONE" class="project-details-info" [ngClass]="{'with-overlay': actionInfoStatus != STATUS_DONE && actionInfoStatus != STATUS_LOADING }" >

  <core-layout-modal-feedback class="modal-feedback" *ngIf="actionInfoStatus == STATUS_NOT_ALLOWED"
    [type]="'warning'"
    [message]="'Forbidden'"
    [text]="'The genereal information could NOT be updated. Please contact your admin for additional support.'"
    [buttonText]="'OK'"
    (action)="onSetInfoError($event)">
  </core-layout-modal-feedback>
  <core-layout-modal-feedback class="modal-feedback" *ngIf="actionInfoStatus == STATUS_ERROR"
      [type]="'fail'"
      [message]="'Error'"
      [text]="'The general information was not updated. Please try again.<br/> If the error persists, please reach out to our support team through the Help Me button.'"
      [buttonText]="'OK'"
      (action)="onSetInfoError($event)">
  </core-layout-modal-feedback>
  <project-details-info-features></project-details-info-features>


  <div class="box_default box_white">
    <header>
      <h3>PROJECT DETAILS</h3>
      <nav><core-helpers-navigation-three-dots-menu
          *ngIf="accessUpload"
          [menu]="menu"
          (action)="onMenuClick($event)"
      ></core-helpers-navigation-three-dots-menu></nav>
    </header>
    <!-- DESCRIPTION -->
    <article *ngIf="project.info != ''" class="project-details-description">
      <header>
        <h4>General Information</h4>
      </header>
      <ng-container *ngIf="generalInfoView; else infoEditor">
        <div class="default-text" [innerHTML]="project.info">{{project.info}}</div>
      </ng-container>
      <ng-template #infoEditor>
        <div class="general-info-editor">
          <core-helpers-forms-wysiwyg-extended
              [content]="project.info"
              [modules]="editorModules"
              (textChange)="onInfoChange($event)"
          ></core-helpers-forms-wysiwyg-extended>
          <!-- BUTTONS -->
          <div class="box_fieldset">
            <core-helpers-forms-button-white [disabled]="!isInfoReady()" [text]="'Save'" (click)= "onInfoSubmit()"></core-helpers-forms-button-white>
            <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="onInfoCancel()"></core-helpers-forms-button>
          </div>
        </div>
      </ng-template>
      
    </article>
      <!-- ATTACHMENTS -->
    <article class="project-details-attachments">
    <project-details-info-attachments
      [showUpload]="showUpload"
      (uploadDone)="onUploadDone($event)"
    ></project-details-info-attachments>
    </article>
    <!-- End ATTACHMENTS -->
    <article *ngIf="project.info != ''" class="project-details-o-version">
    <project-details-info-origin-version></project-details-info-origin-version>
    </article>
  </div>
</div >
